import axios from "axios";
import { createTaskFunctionURL, deleteTokenFunctionURL } from "../Constants";

// Function to collect form data as an object
export const getFormData = (form: HTMLFormElement): Record<string, string | boolean> => {
  const formData = new FormData(form); // Create a FormData object from the form
  const formObject: Record<string, string | boolean> = {};

  // Iterate over all form fields and add them to the object
  formData.forEach((value, key) => {
    const element = form.elements.namedItem(key) as HTMLInputElement | null;

    // Convert checkboxes to boolean values
    if (element && element.type === "checkbox") {
      formObject[key] = element.checked;
    } else {
      formObject[key] = value.toString(); // Convert all values to strings
    }
  });

  return formObject;
};

export const sendToAzureFunction = async (data: Record<string, any>) => {
  try {
    const response = await axios.post(
      createTaskFunctionURL!,
      data,
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    );

    console.log("Data sent to Azure Function successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error sending data to Azure Function:", error);
    throw error;
  }
};

export const deleteToken = async (tokenID: string) => {
  try {
    const response = await axios.post(
      deleteTokenFunctionURL!,
      { tokenID },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Token deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting token:", error);
    throw error;
  }
};